<template>
    <LandingLayout>
        <RouterView />
    </LandingLayout>
</template>

<script lang="ts" setup>
    import LandingLayout from '@/layouts/LandingLayout.vue';
</script>
